var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.banner && (_vm.pc && _vm.isPc || _vm.mobile && _vm.isMobile) ? _c('div', {
    staticClass: "main-visual swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.banner.slides, function (slide, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c(_vm.dynamicComponent(slide.url), {
      tag: "component",
      attrs: {
        "to": slide.url,
        "href": slide.url
      }
    }, [_c('picture', [_c('source', {
      attrs: {
        "srcset": slide.image,
        "media": "(max-width:1200px)"
      }
    }), _c('img', {
      attrs: {
        "src": slide.image,
        "alt": ""
      }
    })])])], 1);
  }), 0), _vm._m(0)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual__controls"
  }, [_c('div', {
    staticClass: "main-visual__prev"
  }), _c('div', {
    staticClass: "main-visual__next"
  })]);
}]

export { render, staticRenderFns }